var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E2DFFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.563 8.55321L11.199 10.9112C10.6877 11.4222 10.0242 11.7533 9.30837 11.8545L12.145 14.6839C12.2447 13.9683 12.5769 13.3054 13.0904 12.7972L15.4544 10.4399L13.563 8.55321ZM13.0904 6.19521L17.8177 10.9119C17.9371 11.0384 18.0025 11.2065 17.9999 11.3804C17.9973 11.5544 17.927 11.7204 17.8038 11.8433C17.6807 11.9662 17.5145 12.0362 17.3405 12.0384C17.1666 12.0406 16.9986 11.9749 16.8724 11.8552L16.3997 11.3832L14.0357 13.7412C13.8492 13.9266 13.7012 14.1471 13.6002 14.39C13.4992 14.6328 13.4472 14.8932 13.4472 15.1562C13.4472 15.4192 13.4992 15.6796 13.6002 15.9225C13.7012 16.1653 13.8492 16.3858 14.0357 16.5712L13.0904 17.5145L10.2677 14.6992L6.95837 17.9999H6.01304V17.0565L9.32237 13.7552L6.47171 10.9112L7.41704 9.96787C7.79331 10.3438 8.30346 10.555 8.83537 10.555C9.36728 10.555 9.87743 10.3438 10.2537 9.96787L12.6177 7.60921L12.1444 7.13787C12.0817 7.07593 12.0318 7.00218 11.9977 6.92089C11.9637 6.8396 11.946 6.75236 11.9458 6.66421C11.9456 6.57607 11.9628 6.48875 11.9965 6.40729C12.0302 6.32584 12.0797 6.25186 12.1421 6.18962C12.2045 6.12737 12.2787 6.0781 12.3602 6.04464C12.4418 6.01117 12.5291 5.99418 12.6173 5.99464C12.7054 5.9951 12.7926 6.013 12.8738 6.0473C12.955 6.08161 13.0286 6.13232 13.0904 6.19521Z",
    fill: "#5B36F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin_icon.f6ad3f0bb254a88776b7af14cab06f87.svg";
export { ForwardRef as ReactComponent };